import { render } from "./Flag.vue?vue&type=template&id=8dee0bda&scoped=true&ts=true"
import script from "./Flag.vue?vue&type=script&lang=ts"
export * from "./Flag.vue?vue&type=script&lang=ts"

import "./Flag.vue?vue&type=style&index=0&id=8dee0bda&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8dee0bda"]])

export default __exports__